/* eslint no-unused-vars: 0, vars-on-top: 0 */
require('babel-polyfill');

var $ = require('jquery');
var _ = require('lodash');
var csrftoken = require('common/csrftoken');
var bootstrap = require('bootstrap/dist/js/bootstrap.js');
var bs4css = require('scss/_custom.scss');
var appCSS = require('scss/styles-prod-listing.scss');
var React = require('react');
var ReactDOM = require('react-dom');
var { queryStringToJSON } = require('common/api/query');
var { ProductionDetailApp } = require('./components/app');
var { Roles } = require('./components/roles');
var { RouteNotFound } = require('common/components/catchall');
var router = require('react-router');
var analytics = require('common/analytics');
var { Header } = require('header/components/header');


$(document)
  .ajaxStart(() => $('.loading').show())
  .ajaxStop(() => $('.loading').hide())
  .ready(() => {
    new analytics.KmqAnalytics(document.title, document.URL).setup();
    if (window.analytics) {
      window.analytics.ready(() => {
        window.analytics.track('Search', {}, {
          integrations: window.SEGMENT_TRACK_DEFAULT_INTEGRATIONS
        });

        window.analytics.track('cc_listing_pageview', { cc_id: window.production_data.id }, { integrations: { 'All': false, 'Webhooks': true } });
      });
    }

    if (window.parselyTrackPageView) {
      window.parselyTrackPageView({
        url: window.location.href,
        js: 1 // flag indicating this is dynamic
      });
    }
  });

// Yes, we have two different rendering trees. the header is not part of the app heirarchy
ReactDOM.render(<Header />, document.getElementById('header__container'));

ReactDOM.render((
  <router.Router history={router.browserHistory}>
    <router.Route path="casting/:productionPath" component={ProductionDetailApp}>
        <router.IndexRoute component={Roles} />
        <router.Route path=":rolePath/" component={Roles} />
    </router.Route>
    <router.Route path="*" component={RouteNotFound} />
  </router.Router>
), document.getElementById('main__container'));



// WEBPACK FOOTER //
// ./bso/frontend/static/js/production_detail/index.js